import gql from 'graphql-tag'
export default gql`mutation updateChlorideClassMutation($chlorideClassId: Int!, $chlorideClass: BaseChlorideClass!) {
  updateChlorideClass(chlorideClassId: $chlorideClassId, chlorideClass: $chlorideClass) {
    code
    description
    maxChloride
    id
  }
}`